<!-- 顶部导航 -->
<template>
  <div class="content tdesign-demo-item--layout">
    <t-layout>
      <t-header>
        <t-head-menu value="item1" height="120px">
          <div class="logout">
            <img width="40" class="logo" src="@/assets/logo.png" alt="logo" />
            <!-- {{ $t('PlatformName') }} -->
            <!-- 管理员-可以修改项目名称-邓婷需求 -->
            <span v-if="!nameState">{{ name }}</span>
            <t-input v-model="name" v-else v-click-outside="sendName" />&nbsp;
            <svg class="icon fontS" aria-hidden="true" @click="nameState = !nameState" v-if="identityId == 1"
              v-show="!nameState">
              <use xlink:href="#icon-edit1"></use>
            </svg>
          </div>
          <t-menu-item value="item2" class="dataBoard" @click="gotoDataBorad">{{ $t('databoard') }}</t-menu-item>
          <t-menu-item value="item2" class="dataBoard" @click="xsjournal">{{ $t('InspectionRecord') }}</t-menu-item>
          <!-- <t-menu-item value="item2" class="dataBoard" @click="goLiveListPage">直播活动</t-menu-item>
          <t-menu-item value="item2" class="dataBoard" @click="goLiveManagement">直播管理</t-menu-item> -->

          <template #operations>
            <t-button variant="text" shape="square" @click="clickAppShow">
              <img src="@/assets/platformIcon/yyzx.png" alt="">
            </t-button>
            &nbsp; &nbsp;

            <!-- 切换语言 -->
            <t-space class="tdesign-demo-dropdown">
              <t-dropdown :options="optionsLang" trigger="click" @click="clickLang">
                  <t-button variant="text" shape="square"> 
                      <icon-font name="translate" size="25px" />
                  </t-button>
              </t-dropdown>
            </t-space>

            &nbsp; &nbsp;
            <img width="32" class="headimg" v-if="avatar" :src="avatar" :onerror="imgError" @click="goUserInfoView"
              alt="logo" />
            <img width="32" class="headimg" v-else src="@/assets/Front/user.png" @click="goUserInfoView" alt="logo" />

            <t-dropdown :options="options" trigger="click" @click="clickHandler">
              <t-space>
                <t-button variant="text">
                  {{ userInfo.name }}
                  <template #suffix> <t-icon name="chevron-down" size="16" /></template>
                </t-button>
              </t-space>
            </t-dropdown>
          </template>
        </t-head-menu>
      </t-header>
    </t-layout>
  </div>
  <AppList ref="applicationList"></AppList>
  <!-- 巡课日志 -->
  <template v-if="visible">
    <Record />
  </template>
</template>

<script setup lang="jsx">
import { useRouter, useRoute } from "vue-router";
import { logout, getloginIdentity } from "@/api/login";
import { getInfoById, saveOrUpdate } from "@/api/AppList";
import { getUserInfo, getUserfileimg, getuserRole } from "@/api/base";
import { isIPAddress } from "@/utils/handleUrl";
import AppList from "@/components/AppList";
import {
  defineAsyncComponent,
  getCurrentInstance,
  ref,
  computed,
  onMounted,
  onBeforeMount,
  onBeforeUnmount,
  reactive,
  provide,
  inject,
} from "vue";
import { IconFont } from "tdesign-icons-vue-next";
import { MessagePlugin } from "tdesign-vue-next";
import { useStore } from "vuex";
import { debounce } from "lodash";
import i18n from "@/utils/i18n";
import Cookies from "js-cookie";
import { useI18n } from "vue-i18n";
const Record = defineAsyncComponent(() =>
  import("@/components/InspectionRecord")
);

const { t } = useI18n();

const userInfo = reactive(JSON.parse(Cookies.get("userInfo")));
console.log(userInfo, "asda");
const router = useRouter();
const route = useRoute();
const store = useStore();

const identityId = localStorage.getItem("Identity"); // 身份id（1：管理员、2：教师、3：学生、4：家长、5：游客）
const nameState = ref(false); // 修改状态
const name = ref(""); // 项目名称
// 项目名称修改
const sendName = debounce(() => {
  let formData = {
    id: "333333", // 用户id
    name: name.value, // 用户名
  };
  // console.log(formData)
  updateInfo(formData);
}, 300);
const updateInfo = (formData) => {
  console.log(formData)
  saveOrUpdate(formData).then((res) => {
    if (res.code == 1) {
      MessagePlugin.success("修改成功");
      nameState.value = false;
      getUserDetail();
    }
  });
};

const options = [
  // { 
  //   content: t("yydl"), 
  //   value: 1,
  //   prefixIcon: ()=>{return (<IconFont name="translate" size="25px" />)}
  // },
  {
    content: t("tcdl"),
    value: 2,
    prefixIcon: () => { return (<IconFont name="logout" size="25px" />) },
  },
];

const applicationList = ref(null);
//打开应用弹窗
function clickAppShow() {
  applicationList.value.Openadd()
}
const optionsLang = [
  {
    content:'简体中文',
    value: 'zh',
  },
  {
    content:'English',
    value: 'en',
  },
  {
    content:'日本語',
    value: 'ja',
  },
];
// 切换语言
function clickLang(data) {

  window.g.LANG = data.value
  localStorage.setItem("lang", data.value);
  i18n.global.locale.value = data.value;
  language.value = data.value;

}


// 下拉框
const language = inject("language");
const clickHandler = (data) => {
  console.log(data);
  if (data.value == 1) {// 语言切换
    window.g.LANG = window.g.LANG === "en" ? "zh" : "en";
    localStorage.setItem("lang", window.g.LANG);
    i18n.global.locale.value = window.g.LANG;
    language.value = window.g.LANG;
  } else if (data.value == 2) {
        // 退出登录
        logout()
        store.commit("setSchoolId", "");
        localStorage.clear();
        sessionStorage.clear();
        Cookies.remove("schoolId");
        Cookies.remove("tokenValue", { domain: window.g.localName });
        Cookies.remove("userInfo");
        if ( Cookies.get('ssoType')=='1' && window.g.SingleSignOn ) {//单点登录退出跳转
          Cookies.remove('ssoType')
          if(window.g.SSO_OUT_Router){
            window.open(window.g.SSO_OUT_URL,'_self')
            return
          } 
        }

      //  window.location.href  = window.location.protocol + '//' + window.location.host + '/hxk/login'
      router.push({ path: "/login" });
      location.reload();

     
  }
};

// 根据用户头像文件id获取头像地址
const avatar = ref(""); // 头像路径 单独修改
// const Userfileimg = (id) => {
//   if (!id) return;
//   getUserfileimg(id).then((res) => {
//     if (res.code === 1) {
//       if (res.data.accessPath && res.data.accessOutPath) {
//         let hostname = window.location.hostname;
//         if (isIPAddress(hostname)) {
//           // 内网
//           avatar.value = res.data.accessPath;
//         } else {
//           // 外网
//           avatar.value = res.data.accessOutPath;
//         }
//       } else {
//         avatar.value = res.data.accessPath
//           ? res.data.accessPath
//           : res.data.accessOutPath;
//       }
//       localStorage.setItem("avatar", avatar.value);
//     }
//   });
// };
// 获取用户信息
const getUserDetail = () => {
  getInfoById({ id: "333333" }).then((res) => {
    if (res.code === 1) {
      const data = res.data;
      name.value = data.name;
      document.head.querySelector("title").innerHTML = data.name;
    }
  });
  getUserInfo(userInfo.userId).then((res) => {
    if (res.code === 1) {
      // Userfileimg(res.data.avatar);
      avatar.value = res.data.avatar;
      localStorage.setItem("avatar", avatar.value);
      // getloginIdentity(res.data.username).then(userData=>{
      //   if(userData.code == 1){
      //     if(userData.data.length > 0){
      //       if(userData.data[0].identityId == 1){
      //         router.push({ path: "/SCADA" });
      //       }else{
      //         router.push({ path: "/FreeCourse" });
      //       }
      //     }
      //   }
      // })
    }
  });
};

// 图片裂开无法显示
const imgError = (e) => {
  let img = e.srcElement;
  img.src = require("@/assets/Front/user.png");
  img.onerror = null;
};

const gotoDataBorad = () => {
  let href = window.location.protocol + '//' + window.location.host + '/hztgl/AI/dataPreview'
  window.open(href)
}

const visible = ref(false);
provide("visible", visible);
const xsjournal = () => {
  visible.value = !visible.value;
}

// 获取用户身份 1管理员 0非管理员
getuserRole().then(res => {
  sessionStorage.setItem("UserIsAdmin", JSON.stringify(res.data))
});

onBeforeMount(() => {
  getUserDetail();
});
onMounted(() => {
});

const goLiveListPage = () =>  {
  // 跳转前台直播活动列表页
  router.push({
    path: "/back/liveListPage",
  });
}

const goLiveManagement = () => {
  // 跳转直播管理页
  router.push({
    path: "/back/LiveManagement",
  });
}

const goUserInfoView = () => {
  // 跳转个人信息页
  router.push({
    path: "/wenxiang/userInfo",
  });
};
</script>

<style lang="less" scoped>
@import "./index.less";
</style>
